import TicketService from '@/services/api/ticketService'
import { Calendar, Clock, QrCode, Ticket, X } from 'lucide-react'
import React from 'react'

const Tickets = ({ tickets }) => {
  const handleCancelTicket = async (ticket) => {
    if (confirm('Bilet iptal etmek istediğine emin misin?')) {
      await TicketService.cancel(ticket)
      window.location.reload()
    }
  }

  if (!tickets?.length) {
    return null
  }

  return (
    <div className='space-y-3'>
      <h3 className='font-bold text-lg text-black-100 line-clamp-2'>Biletlerim</h3>
      {tickets.map((ticket) => (
        <div key={ticket.id} className='bg-white border border-[#AC5E2A] rounded-xl shadow-md overflow-hidden cursor-pointer hover:shadow-xl transition-shadow'>
          <div className='p-3 relative space-y-4'>
            <div className='space-y-2'>
              {ticket.date && (
                <div className='flex items-center text-sm text-gray-600'>
                  <Calendar size={16} className='mr-2 text-[#AC5E2A]' />
                  <span>
                    <strong>Tarih: </strong>
                    {ticket.date}
                  </span>
                </div>
              )}

              {ticket.hour && (
                <div className='flex items-center text-sm text-gray-600'>
                  <Clock size={16} className='mr-2 text-[#AC5E2A]' />
                  <span>
                    <strong>Saat: </strong>
                    {ticket.hour}
                  </span>
                </div>
              )}

              {ticket.bilet_no && (
                <div className='flex items-center text-sm text-gray-600'>
                  <Ticket size={16} className='mr-2 text-[#AC5E2A]' />
                  <span>
                    <strong>Bilet: </strong>
                    {ticket.bilet_no}
                  </span>
                </div>
              )}
              <button
                onClick={() => {
                  handleCancelTicket(ticket)
                }}
                className='mt-3 p-2 flex gap-1 text-sm w-full justify-center items-center text-white bg-red-600 rounded-lg hover:bg-red-800 transition-colors'
              >
                <X size={20} className='text-white' /> Bilet İptal Et
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Tickets
